import { observer } from 'mobx-react';
import { autoinject, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { Route, RouteComponentProps } from 'react-router';
import { AppStore } from '../Core/AppStore';
import { AccountsList } from './AccountsList';
import { ManageContractDisplays } from '../Contracts/ManageContractDisplays';

export interface IAccountsViewProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class AccountsView extends React.Component<IAccountsViewProps> {
    public render() {
        return (
            <>
                <Route path="/accounts" exact component={AccountsList} />
                <Route path="/accounts/:contractCO" exact component={ManageContractDisplays} />
            </>
        );
    }

    @inject
    private appStore!: AppStore;
}
